import { render, staticRenderFns } from "./NftContractStep.vue?vue&type=template&id=18893f33&"
import script from "./NftContractStep.vue?vue&type=script&lang=js&"
export * from "./NftContractStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports